import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useAddTaskMutation,
  useGetProjectsQuery,
  useGetTeamsQuery,
} from "../../features/api/apiSlice";

const AddForm = () => {
  const { data: projects } = useGetProjectsQuery();
  const { data: teams } = useGetTeamsQuery();
  const [addTask, { isSuccess }] = useAddTaskMutation();
  const navigate = useNavigate();

  const [taskName, setTaskName] = useState("");
  const [teamMember, setTeamMember] = useState("");
  const [projectName, setProjectName] = useState("");
  const [deadline, setDeadline] = useState("");

  const onSubmitHandler = (e) => {
    e.preventDefault();

    const findProject = projects?.find((p) => p.projectName === projectName);
    const findTeam = teams?.find((t) => t.name === teamMember);

    const data = {
      taskName,
      teamMember: {
        ...findTeam,
      },
      project: { ...findProject },
      deadline,
    };

    addTask(data);

    navigate("/");
  };

  return (
    <form className="space-y-6" onSubmit={onSubmitHandler}>
      <div className="fieldContainer">
        <label htmlFor="lws-taskName">Task Name</label>
        <input
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          placeholder="Implement RTK Query"
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select
          name="teamMember"
          id="lws-teamMember"
          required
          value={teamMember}
          onChange={(e) => setTeamMember(e.target.value)}
        >
          <option value="" hidden>
            Select Job
          </option>
          {teams?.map((t) => (
            <option key={t.id}>{t.name}</option>
          ))}
        </select>
      </div>
      <div className="fieldContainer">
        <label htmlFor="lws-projectName">Project Name</label>
        <select
          id="lws-projectName"
          name="projectName"
          required
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
        >
          <option value="" hidden>
            Select Project
          </option>
          {projects?.map((p) => (
            <option key={p.id}>{p.projectName}</option>
          ))}
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-deadline">Deadline</label>
        <input
          type="date"
          name="deadline"
          id="lws-deadline"
          required
          value={deadline}
          onChange={(e) => setDeadline(e.target.value)}
        />
      </div>

      <div className="text-right">
        <button type="submit" className="lws-submit" disabled={isSuccess}>
          Save
        </button>
      </div>
    </form>
  );
};

export default AddForm;
